import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const CustomDatePicker = ({ selectedDate, setSelectedDate, label, error }) => {
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate); 
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={selectedDate}
        onChange={handleDateChange}
        label={label}
        slotProps={{
          textField: {
            fullWidth: true,
            error: !!error,
            helperText: error,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
